/*
 * @Description:
 * @Author: Teemo Ding
 * @Date: 2021-04-14 15:12:16
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-05 11:01:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/SEOSetting/index.tsx
 */
import React from 'react';

import { Checkbox, Input, TextArea } from '@/src/components/Antd';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import Slug from 'src/constrains/SlugInput';
import css from './css.module.less';

import { validateSeoSetting } from '../tools';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getContentDetails,
  getSeoSetting,
  onCollapseOpen,
  onErrorChange,
  onSEOSettingOnChange,
} from '../slice';

const SEOSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, isOnPrimaryLanguage, disabled } = props;
  const _d = useDispatch();
  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const contentDetails = useSelector(getContentDetails());
  const { productName, productDescription } = contentDetails;
  const { customized, title, description, urlSlug, slugValid } = data;
  const { salesChannelProductUuid, saleChannelUuid } = _params;

  const handleOnTitleChange = (value) => {
    _d(onSEOSettingOnChange({ data: { title: value } }));
  };
  const handleOnDescriptionChange = (value) => {
    _d(onSEOSettingOnChange({ data: { description: value } }));
  };

  const handleSlugOnChange = ({ slug, valid }) => {
    _d(onSEOSettingOnChange({ data: { urlSlug: slug, slugValid: valid } }));
  };
  const handleOnCustomChange = (value) => {
    _d(onSEOSettingOnChange({ data: { customized: value } }));
  };
  return (
    <React.Fragment>
      <Section bottomBorder>
        <div className={css.enabledContainer}>
          <Checkbox
            checked={customized}
            disabled={disabled}
            onChange={handleOnCustomChange}>
            {getI18n(
              'salesChannelProductAlias.editPage.pagetitledescriptioncustomization',
            )}
          </Checkbox>
        </div>
      </Section>
      <Section bottomBorder>
        {customized ? (
          <ItemWrapper
            title={getI18n('general.title')}
            rightPart={
              <CountWords count={(title || '').length} allCount={100} />
            }>
            <Input
              value={title}
              onChange={handleOnTitleChange}
              size='large'
              placeholder={`${getI18n('general.title')} (0/100)`}
              maxLength={100}
              disabled={disabled}
            />
          </ItemWrapper>
        ) : (
          <ItemWrapper title={getI18n('general.title')}>
            <div>{productName || '-'}</div>
          </ItemWrapper>
        )}
        {customized ? (
          <ItemWrapper
            rightPart={
              <CountWords count={(description || '').length} allCount={500} />
            }
            title={getI18n(
              'salesChannelProductAlias.editPage.metaDescription',
            )}>
            <TextArea
              value={description}
              onChange={handleOnDescriptionChange}
              maxLength={500}
              placeholder={`${getI18n(
                'salesChannelProductAlias.editPage.metaDescription',
              )} (0/500)`}
              disabled={disabled}
            />
          </ItemWrapper>
        ) : (
          <ItemWrapper
            title={getI18n(
              'salesChannelProductAlias.editPage.metaDescription',
            )}>
            <div>{productDescription || '-'}</div>
          </ItemWrapper>
        )}
        {isOnPrimaryLanguage && (
          <Slug
            displayDangerousNotice
            value={urlSlug}
            url={'portal/salesChannelProductContent/slug/duplicate'}
            fixedParams={{
              salesChannelUuid: saleChannelUuid,
              salesChannelProductUuid:
                salesChannelProductUuid == 'null'
                  ? ''
                  : salesChannelProductUuid,
            }}
            slugValid={slugValid}
            disabled={disabled}
            onChange={handleSlugOnChange}
          />
        )}
      </Section>
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(SEOSetting, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.seoSetting,
  getContent: getSeoSetting,
  title: getI18nFromGeneral('general.hOCTitle.productSEOSetting'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, _p) => {
    const { isPrimary } = _p;
    return validateSeoSetting(x, isPrimary);
  },
});
